import { db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

export const saveImageSettings = async (shopId, shopDomain, settings) => {
  try {
    console.log('Saving settings for shop:', shopDomain, 'with ID:', shopId);
    const shopDocRef = doc(db, 'shops', shopId);
    
    // Get current document first
    const docSnap = await getDoc(shopDocRef);
    if (!docSnap.exists()) {
      throw new Error('Shop document not found. Please ensure you have a valid shop connection.');
    }

    // Update only the imageSettings field
    await updateDoc(shopDocRef, {
      'imageSettings.format': settings.format,
      'imageSettings.compressionLevel': settings.compressionLevel,
      'imageSettings.maxWidth': settings.maxWidth,
      'imageSettings.maxHeight': settings.maxHeight,
      'imageSettings.useSeoNaming': settings.useSeoNaming,
      'imageSettings.artist': settings.artist || '',
      'imageSettings.comment': settings.comment || '',
      'imageSettings.copyright': settings.copyright || '',
      'imageSettings.imageDescription': settings.imageDescription || '',
      'imageSettings.updatedAt': new Date().toISOString()
    });
    
    return true;
  } catch (error) {
    console.error('Error saving image settings:', error);
    throw error;
  }
};

export const getImageSettings = async (shopId) => {
  try {
    console.log('Loading settings for shop with ID:', shopId);
    const shopDocRef = doc(db, 'shops', shopId);
    const docSnap = await getDoc(shopDocRef);
    
    if (docSnap.exists() && docSnap.data().imageSettings) {
      return docSnap.data().imageSettings;
    }
    
    // Return default settings if none exist
    return {
      format: 'none',
      compressionLevel: 'medium',
      maxWidth: null,
      maxHeight: null,
      useSeoNaming: true,
      artist: '',
      comment: '',
      copyright: '',
      imageDescription: ''
    };
  } catch (error) {
    console.error('Error getting image settings:', error);
    throw error;
  }
};
